import { getDatabaseTables } from '../../../modules/databases/databases.repository';
import { Table } from '../../../modules/tables/types';

export const getDatabaseTablesUseCase = (databaseSlug: string): Promise<Table[]> => {
  return getDatabaseTables(databaseSlug);
};
